import { classNames } from "primereact/utils";

// Abas de filtro por status, com a contagem de cada uma
const StatusTabs = ({ tabs, value, onChange, counts, loading, ariaLabel }) => (
  <div className="admin-list-tabs" role="tablist" aria-label={ariaLabel}>
    {tabs.map((tab) => (
      <button
        key={tab.value}
        type="button"
        role="tab"
        aria-selected={value === tab.value}
        className={classNames("admin-list-tabs__tab", {
          "admin-list-tabs__tab--active": value === tab.value,
        })}
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
        <span className="admin-list-tabs__count">{loading ? "…" : counts?.[tab.value] ?? 0}</span>
      </button>
    ))}
  </div>
);

export default StatusTabs;
